var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavReceiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.011 8.125a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm8.864 15.4a2.376 2.376 0 0 1-.637-2.475 2.403 2.403 0 0 1 1.974-1.663l1.563-.224s.25-.024.325-.175l.5-1a.414.414 0 0 0 .05-.238.395.395 0 0 0-.1-.188 6.606 6.606 0 0 0-5.05-1.937h-5c-5.075 0-6.875 3.712-6.875 6.9 0 2.85 1.513 4.35 4.375 4.35h9.488c.2 0 .327-.15.387-.475l.25-1.438a.347.347 0 0 0-.113-.337l-1.137-1.1Zm10.959-1.351a.544.544 0 0 0-.309-.931l-2.49-.354a.557.557 0 0 1-.419-.299l-1.08-2.14a.601.601 0 0 0-1.069 0l-1.078 2.14a.557.557 0 0 1-.419.299l-2.49.354a.543.543 0 0 0-.309.93l1.8 1.718a.54.54 0 0 1 .162.485l-.412 2.349a.592.592 0 0 0 .864.616l2.159-1.11a.562.562 0 0 1 .517 0l2.16 1.111a.593.593 0 0 0 .863-.616l-.409-2.351a.542.542 0 0 1 .16-.485l1.799-1.716Z",
    fill: "#1C3F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavReceiver);
export default __webpack_public_path__ + "static/media/fav-receiver.5b3c04eab680e6f08b253d147a9f9636.svg";
export { ForwardRef as ReactComponent };